/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { makeStyles } from "@material-ui/core";

export const useSourceInfoDrawerHeaderStyles = makeStyles((theme) => {
    return {
        root: {
            paddingRight: theme.spacing(1.5),
        },
    };
});
